export enum PersonSex {
  Male = 'male',
  Female = 'female',
  Diverse = 'diverse',
}
